import { useState, useEffect, useRef } from "react";
import "../styles/Profile.css";
import { FaUser, FaCamera } from "react-icons/fa";
import { useNotification } from "../components/NotificationContext";

const Profile = () => {
  const { showNotification } = useNotification();
  const [userData, setUserData] = useState({
    id: "",
    name: "",
    especialidade: "",
    cep: "",
    rua: "",
    numeroLocalidade: "",
    bairro: "",
    cidade: "",
    estado: "",
    fotoPerfil: null,
  });
  const [profileImage, setProfileImage] = useState(null);

  const [negocios, setNegocios] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [novoNegocio, setNovoNegocio] = useState({
    nome: "",
    cep: "",
    cidade: "",
    endereco: "",
    telefone: "",
    descricao: "",
    photo: null,
  });

  const [previewImage, setPreviewImage] = useState(userData.fotoPerfil);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    if (storedUserData) {
      setUserData({ 
        ...storedUserData, 
        fotoPerfil: storedUserData.fotoPerfil || null 
      });
      
      // Set preview image from stored user data
      if (storedUserData.fotoPerfil) {
        setPreviewImage(storedUserData.fotoPerfil);
      }
    }
    listarNegocios();
  }, []);

  const handleInputChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const buscarEnderecoNoForm = async () => {
    if (userData.cep && String(userData.cep).length === 8)  {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${userData.cep}/json/`);
        const data = await response.json();
        if (!data.erro) {
          setUserData((prevData) => ({
            ...prevData,
            rua: data.logradouro || "",
            bairro: data.bairro || "",
            cidade: data.localidade || "",
            estado: data.uf || "",
          }));
        } else {
          showNotification("CEP inválido.", "error");
        }
      } catch (error) {
        showNotification("Erro ao buscar endereço.", "error");
      }
    }
  };
  const buscarEnderecoNovoNegocio = async () => {
    if (novoNegocio.cep && String(novoNegocio.cep).length === 8) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${novoNegocio.cep}/json/`);
        const data = await response.json();
        if (!data.erro) {
          setNovoNegocio((prevData) => ({
            ...prevData,
            rua: data.logradouro || "",
            bairro: data.bairro || "",
            cidade: data.localidade || "",
            estado: data.uf || "",
          }));
        } else {
          showNotification("CEP inválido.", "error");
        }
      } catch (error) {
        showNotification("Erro ao buscar endereço.", "error");
      }
    }
  };
  const atualizarPerfil = async () => {
    try {
      // Just update the profile data without handling image upload
      // (Image upload is now handled separately in uploadProfileImage)
      const localUserData = { ...userData };
      localStorage.setItem("userData", JSON.stringify(localUserData));
      
      // Make an API call to update other user data if needed
      // This depends on what the API expects, but we're just updating localStorage for now
      
      showNotification("Informações atualizadas com sucesso!", "success");
    } catch (error) {
      console.error("Erro ao atualizar perfil:", error);
      showNotification("Erro ao atualizar perfil. Por favor, tente novamente.", "error");
    }
  };

  const abrirModal = () => setModalAberto(true);
  const fecharModal = () => setModalAberto(false);

  const cadastrarNegocio = async () => {
    const storedUser = localStorage.getItem("userData");
  
    if (!storedUser) {
      showNotification("Usuário não identificado.", "error");
      return;
    }
  
    const userData = JSON.parse(storedUser);
    const userId = userData.id;
  
    if (
      !novoNegocio.nome ||
      !novoNegocio.cep ||
      !novoNegocio.cidade ||
      !novoNegocio.endereco ||
      !novoNegocio.telefone ||
      !novoNegocio.descricao
    ) {
      showNotification("Preencha todos os campos obrigatórios.", "warning");
      return;
    }
  
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("CEP", novoNegocio.cep);
    formData.append("nome", novoNegocio.nome);
    formData.append("descricao", novoNegocio.descricao);
    formData.append("cidade", novoNegocio.cidade);
    formData.append("endereco", novoNegocio.endereco);
    formData.append("telefone", novoNegocio.telefone);
    formData.append("rating", novoNegocio.rating || 0);
  
    if (novoNegocio.photo) {
      formData.append("photo", novoNegocio.photo);
    }
  
    try {
      const response = await fetch("https://x8ki-letl-twmt.n7.xano.io/api:1gyP90jK/negocios", {
        method: "POST",
        body: formData,
      });
  
      if (!response.ok) throw new Error("Erro ao cadastrar negócio.");
  
      listarNegocios();
      fecharModal();
      showNotification("Negócio cadastrado com sucesso!", "success");
    } catch (error) {
      showNotification("Erro ao cadastrar o negócio.", "error");
      console.error(error);
    }
  };
  

  const listarNegocios = async () => {
    try {
      const cachedUserData = localStorage.getItem("userData");
      const userData = cachedUserData ? JSON.parse(cachedUserData) : null;
      console.log("Dados do usuário:", userData);
      const userId = userData ? userData.id : null;

      if (!userId) {
        console.error("Usuário não identificado.");
        setNegocios([]);
        return;
      }

      const cachedData = localStorage.getItem("negocios_cache");
    
      if (cachedData) {
        const parsedData = JSON.parse(cachedData);
        if (Array.isArray(parsedData)) {
          setNegocios(parsedData);
        } else {
          console.error("Cache de negócios não é um array:", parsedData);
          setNegocios([]);
          localStorage.removeItem("negocios_cache");
        }
        return;
      }
    
      const response = await fetch(`https://x8ki-letl-twmt.n7.xano.io/api:1gyP90jK/negocios?user_id=${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        }
      });
      const data = await response.json();
      console.log("Retorno da API:", data);
    
      if (Array.isArray(data)) {
        setNegocios(data);
        localStorage.setItem("negocios_cache", JSON.stringify(data));
      } else {
        console.error("Resposta da API de negócios não é um array:", data);
        setNegocios([]);
      }
    } catch (error) {
      console.error("Erro ao listar negócios:", error);
      setNegocios([]);
    }
  };
  

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) { // 5MB
      showNotification("A imagem é muito grande. Por favor, escolha uma imagem menor que 5MB.", "warning");
      return;
    }

    // Store the actual file object for form submission
    setProfileImage(file);

    // Create a preview for display
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(file);
    
    // Upload the image immediately if desired
    uploadProfileImage(file);
  };
  
  const uploadProfileImage = async (imageFile) => {
    try {
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      if (!storedUserData || !storedUserData.id) {
        console.error("Usuário não identificado para upload de imagem");
        return;
      }
      
      const formData = new FormData();
      formData.append("user_id", storedUserData.id);
      formData.append("photo", imageFile);
      
      // Log what we're sending
      console.log("Uploading image for user:", storedUserData.id);
      console.log("Image file:", imageFile.name, imageFile.type, imageFile.size);
      
      const response = await fetch("https://x8ki-letl-twmt.n7.xano.io/api:1gyP90jK/usuarios/upload_photo", {
        method: "POST",
        body: formData,
      });
      
      const text = await response.text();
      console.log("Raw response:", text);
      
      if (!response.ok) {
        throw new Error(`Upload failed with status ${response.status}: ${text}`);
      }
      
      let data;
      try {
        data = JSON.parse(text);
      } catch (err) {
        console.error("Error parsing JSON response:", err);
        return;
      }
      
      console.log("Upload successful:", data);
      
      if (data && data.photo_url) {
        // Update the userData in state and localStorage
        const updatedUserData = {
          ...userData,
          fotoPerfil: data.photo_url
        };
        
        setUserData(updatedUserData);
        localStorage.setItem("userData", JSON.stringify(updatedUserData));
        showNotification("Foto de perfil atualizada com sucesso!", "success");
      }
    } catch (error) {
      console.error("Erro ao fazer upload da imagem:", error);
      showNotification("Não foi possível fazer o upload da imagem. Por favor, tente novamente.", "error");
    }
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    setProfileImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className="profile-container">
      <h2>Atualize suas informações</h2>

      <div className="image-upload-wrapper">
        <div className="profile-image" onClick={handleImageClick}>
          {previewImage ? (
            <img src={previewImage} alt="Foto de perfil" style={{
              cursor: "pointer",
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              objectFit: "cover",
            }} />
          ) : (
            <div className="default-avatar" style={{
              cursor: "pointer",
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              backgroundColor: "#ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "50px",
            }}>
              <FaUser />
            </div>
          )}
          <div className="image-overlay">
            <FaCamera />
          </div>
        </div>
        <input
          type="file"
          id="fotoPerfil"
          accept="image/*"
          style={{ display: "none" }}
          ref={fileInputRef}
          onChange={handleImageChange}
        />
        <br />
        <label htmlFor="fotoPerfil" style={{ cursor: "pointer" }}>
          Foto de Perfil
        </label>
        {previewImage && (
          <button 
            onClick={handleRemoveImage}
            style={{
              marginTop: "5px",
              padding: "5px 10px",
              backgroundColor: "#f44336",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Remover Foto
          </button>
        )}
      </div>

      <form className="update-form">
        <label>Nome de visualização:</label>
        <input
          type="text"
          name="name"
          value={userData.name}
          onChange={handleInputChange}
          required
        />

        <label>Especialidade:</label>
        <input
          type="text"
          name="especialidade"
          value={userData.especialidade}
          onChange={handleInputChange}
          required
        />

        <label>CEP:</label>
        <input
          type="text"
          name="cep"
          value={userData.cep}
          onChange={handleInputChange}
          onBlur={buscarEnderecoNoForm}
          required
        />

        <label>Rua:</label>
        <input type="text" name="rua" value={userData.rua} readOnly />

        <label>Número:</label>
        <input
          type="number"
          name="numeroLocalidade"
          value={userData.numeroLocalidade}
          onChange={handleInputChange}
          required
        />

        <label>Bairro:</label>
        <input type="text" name="bairro" value={userData.bairro} readOnly />

        <label>Cidade:</label>
        <input type="text" name="cidade" value={userData.cidade} readOnly />

        <label>Estado:</label>
        <input type="text" name="estado" value={userData.estado} readOnly />
      </form>

      <div className="button-group">
        <button className="update-button" onClick={atualizarPerfil}>
          Atualizar informações
        </button>
      </div>

      <div class="linha-divisoria"></div>
        
      <div className="group negocios">
        <h3>Meus Negócios</h3>
        <button className="register-business-button" onClick={abrirModal}>
            Cadastrar Novo Negócio
        </button>
      </div>
      <div className="business-list">
        {Array.isArray(negocios) && negocios.length > 0 ? (
          negocios.map((negocio, index) => (
            <div key={index} className="business-card">
              <div className="business-info">
                <h4>{negocio?.nome || "Nome não disponível"}</h4>
                <p>
                  <strong>Nota:</strong> {negocio?.rating || 0}/5
                </p>
              </div>
              <div className="business-details">
                <p><strong>Telefone:</strong> {negocio?.telefone || "Não informado"}</p>
                <p><strong>Descrição:</strong> {negocio?.descricao || "Não informada"}</p>
                <p><strong>Cidade:</strong> {negocio?.cidade || "Não informada"}</p>
                <p><strong>Endereço:</strong> {negocio?.endereco || "Não informado"}</p>
                <p><strong>CEP:</strong> {negocio?.CEP || "Não informado"}</p>
              </div>
            </div>
          ))
        ) : (
          <p>Nenhum negócio cadastrado ainda.</p>
        )}
      </div>

      {modalAberto && (
        <div className="modal">
          <div className="modal-content">
            <h2>Cadastrar Novo Negócio</h2>
            <input
              type="text"
              placeholder="Nome do Negócio"
              value={novoNegocio.nome}
              onChange={(e) =>
                setNovoNegocio({ ...novoNegocio, nome: e.target.value })
              }
            />
            <input
              type="text"
              placeholder="CEP"
              value={novoNegocio.cep}
              onChange={(e) => {
                const cep = e.target.value.replace(/\D/g, "");

                setNovoNegocio((prev) => ({
                  ...prev,
                  cep: cep,
                }));

                if (cep.length === 8) {
                  buscarEnderecoNovoNegocio();
                }
              }}
              maxLength={8}
            />
            <input
              type="text"
              placeholder="Cidade"
              value={novoNegocio.cidade}
              onChange={(e) =>
                setNovoNegocio({ ...novoNegocio, cidade: e.target.value })
              }
            />
            <input
              type="text"
              placeholder="Endereço"
              value={novoNegocio.endereco}
              onChange={(e) =>
                setNovoNegocio({ ...novoNegocio, endereco: e.target.value })
              }
            />
            <input
              type="text"
              placeholder="Telefone"
              value={novoNegocio.telefone}
              onChange={(e) =>
                setNovoNegocio({ ...novoNegocio, telefone: e.target.value })
              }
            />
            <textarea
              placeholder="Descrição"
              value={novoNegocio.descricao}
              onChange={(e) =>
                setNovoNegocio({ ...novoNegocio, descricao: e.target.value })
              }
            ></textarea>
            <div className="image-upload-wrapper">
              <label htmlFor="photoNegocio" style={{ cursor: "pointer" }}>
                Foto do Negócio
              </label>
              <input
                type="file"
                id="photoNegocio"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) =>
                  setNovoNegocio({ ...novoNegocio, photo: e.target.files[0] })
                }
              />
            </div>
            <button onClick={cadastrarNegocio}>Salvar</button>
            <span className="cancel-button" onClick={fecharModal}>
              &times;
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
